<template>
  <div id="home" class="lg:bg-white w-full lg:z-50 lg:fixed lg:shadow-lg">
    <container>
      <nav class="w-full mx-auto lg:opacity-95 lg:bg-white mt-4">
        <div class="flex items-center w-full justify-between">
          <div class="w-1/3">
            <router-link to="/">
              <img src="../../public/logo.webp" alt="logo marca" width="180"
                   height="180">
            </router-link>
          </div>
          <!-- nav bar -->

          <div class="w-3/5 hidden lg:flex justify-between">
            <ul class="flex items-center justify-center gap-x-12"
                v-for="link in navLinks"
                :key="link"
            >
              <li>
                <router-link
                    class=" font-normal hover:text-blue-700 text-lg"
                    exactActiveClass="text-blue-600"
                    activeClass="text-blue-600"
                    :class="[ $route.hash === link.link ? 'text-blue-600' : 'text-slate-700',

                     ]"
                    :title="link.title"
                    :to="{path: '/', hash: link.link}"
                >
                  {{ link.title }}
                </router-link>
              </li>
            </ul>
            <div class="items-end p-3 rounded-full">
              <ul class="flex items-center justify-center gap-x-1">
                <li class="p-3 rounded-full bg-white hover:scale-105">
                  <a class="text-pink-600" href="https://www.instagram.com/clinicabiancaeluisa/"
                     target="_blank" rel="noopener noreferrer" title="Acesse nosso Instagram.">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                         class="bi bi-instagram" viewBox="0 0 16 16">
                      <path
                          d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                    </svg>
                  </a>
                </li>
                <li class="p-3 rounded-full bg-white hover:scale-105">
                  <a class="text-blue-600" href="https://www.facebook.com/clinicabiancaeluisa"
                     target="_blank" rel="noopener noreferrer" title="Acesse nosso Facebook.">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                         class="bi bi-facebook" viewBox="0 0 16 16">
                      <path
                          d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                    </svg>
                  </a>
                </li>
                <li class="p-3 rounded-full bg-white hover:scale-105">
                  <a class="text-green-600"
                     href="https://api.whatsapp.com/send?phone=5546991166942&text=Ol%C3%A1%2C%20venho%20atrav%C3%A9s%20da%20p%C3%A1gina%20e%20gostaria%20de%20agendar%20uma%20pr%C3%A9-consulta%C2%A0gratuita"
                     target="_blank" rel="noopener noreferrer" title="Fale conosco via Whatsapp clicando aqui.">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                         class="bi bi-whatsapp" viewBox="0 0 16 16">
                      <path
                          d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!--    end navbar    -->
          <!-- responsive nav -->
          <div class="mr-4 lg:hidden block active:text-blue-700">
            <!--  hamburger icon        -->
            <button type="button" @click="handleMenu()" title="Clicando aqui o menu de navegação será aberto.">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="w-6 h-6 text-slate-700  hover:text-blue-700 lg:hidden">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"/>
              </svg>
            </button>
          </div>

        </div>

        <div
            id="nav"
            class="fixed top-0 right-0 w-full opacity-100 h-full bg-white transform translate-x-full
          transition-transform duration-300 z-50 shadow-lg lg:hidden"
        >
          <div class="mt-4 flex justify-end mr-2 active:text-red-500 text-right" @click="handleMenu()">
            <!--  x icon to close menu        -->
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>

          </div>
          <ul
              id="ul"
              class="flex flex-col p-5 mr-4 space-y-4"
              v-for="link in navLinks"
              :key="link"
          >
            <li @click="handleMenu()">
              <router-link
                  class="text-slate-700 font-normal hover:text-blue-700 text-lg"
                  :title="link.title"
                  :to="{path: '/', hash: link.link}"
              >
                {{ link.title }}
              </router-link>
            </li>
          </ul>

          <div
              class="w-full px-10 pt-4 flex flex-col lg:flex-row bg-white mx-auto justify-center items-center pb-12">
            <div class="flex w-full flex-col mx-auto justify-center items-center order-3 lg:order-1 lg:mt-12">
              <nav>
                <ul class="space-x-4 text-start flex">
                  <li class="p-3 rounded-full bg-white hover:scale-105">
                    <a class="text-pink-600" href="https://www.instagram.com/clinicabiancaeluisa/"
                       target="_blank" rel="noopener noreferrer" title="Acesse nosso Instagram.">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                           class="bi bi-instagram" viewBox="0 0 16 16">
                        <path
                            d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                      </svg>
                    </a>
                  </li>
                  <li class="p-3 rounded-full bg-white hover:scale-105">
                    <a class="text-blue-600" href="https://www.facebook.com/clinicabiancaeluisa"
                       target="_blank" rel="noopener noreferrer" title="Acesse nosso Facebook.">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                           class="bi bi-facebook" viewBox="0 0 16 16">
                        <path
                            d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                      </svg>
                    </a>
                  </li>
                  <li class="p-3 rounded-full bg-white hover:scale-105">
                    <a class="text-green-600"
                       href="https://api.whatsapp.com/send?phone=5546991166942&text=Ol%C3%A1%2C%20venho%20atrav%C3%A9s%20da%20p%C3%A1gina%20e%20gostaria%20de%20agendar%20uma%20pr%C3%A9-consulta%C2%A0gratuita"
                       target="_blank" rel="noopener noreferrer" title="Fale conosco via Whatsapp clicando aqui.">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                           class="bi bi-whatsapp" viewBox="0 0 16 16">
                        <path
                            d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
                      </svg>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </nav>
    </container>
  </div>
</template>

<script>
import Container from '@/components/partials/Container.vue'

export default {
  name: "NavBar",
  components: {
    container: Container,
  },
  data() {
    return {
      isActive: true,
      navLinks: {
        home: {
          title: "Home",
          link: "",
        },
        fascias: {
          title: "Fáscias",
          link: "#fascias",
        },
        /*servicos: {
          title: "Serviços",
          link: "#servicos",
        },*/
        clinica: {
          title: "Bianca Eluisa",
          link: "#biancaEluisa",
        },
        depoimentos: {
          title: "Depoimentos",
          link: "#depoimentos",
        },
        contato: {
          title: "Contato",
          link: "#contato",
        },
      }
    }
  },
  methods: {
    handleMenu() {
      const nav = document.getElementById("nav");
      if (nav.classList.contains("translate-x-full")) {
        nav.classList.remove("translate-x-full");
        nav.classList.add("translate-x-0");
      } else {
        nav.classList.remove("translate-x-0");
        nav.classList.add("translate-x-full");
      }
    },
  },
};
</script>